import { Grid, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import styles from './authCommonCard.module.scss'

import { useState } from 'react'
import { forgotPassword } from '../../features/authSlice.js'
import InputCustom from '../atoms/input/InputCustom.jsx'
import { CooldownButton } from '../buttons/CooldownButton.jsx'

const AuthCommonForm = ({ title, children, subTitle, form, ...rest }) => {
	const [email, setEmail] = useState('')

	return (
		<Grid size={{ xs: 12, sm: 6 }}>
			<div className={styles.formContainer} {...rest}>
				<div className={styles.titleContainer}>
					{title && <Typography variant="h4">{title}</Typography>}
					{subTitle && <Typography>{subTitle}</Typography>}
				</div>
				{form && (
					<form
						className={styles.form}
						onSubmit={(e) => e.preventDefault()}
					>
						<div className={styles.formGroup}>
							<InputCustom
								autoFocus={true}
								required={true}
								type="email"
								placeholder="Email Address"
								name="email"
								onChange={(e) =>
									setEmail(e.target.value.toLowerCase())
								}
							/>
						</div>

						<div className={`${styles.skipBtn}`}>
							<Link
								to="/forgot-password"
								data-cy="go-to-forgot-password"
								className={styles.forgotPassword}
							>
								Back{' '}
							</Link>
							<CooldownButton
								dispatchFunction={forgotPassword}
								dispatchData={email}
								buttonText="Send reset link"
								cooldownSeconds={15}
							/>
						</div>
					</form>
				)}
				{/* middle content goes here */}

				{children}
			</div>
		</Grid>
	)
}

export default AuthCommonForm
